import { HttpParams } from "@angular/common/http";
import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  TemplateRef,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom } from "rxjs";
import { PdfSanitizerService } from "src/app/core/pdf-sanitizer.service";
import { LoadingService } from "src/app/core/services/loading.service";
import { LoteDetalleUrlService } from "src/app/core/services/lote-detalle-url.service";
import { LoteService } from "src/app/core/services/lote.service";
import { FirmaStateService } from "src/app/core/states/firma/firma-state.service";
import { HelpToursService } from "src/app/core/tours/help-tours.service";
import { Lote } from "src/app/models/Lote.model";
import { LoteDetalleUrl } from "src/app/models/LoteDetalleUrl.model";
import { FileUploadComponent } from "src/app/shared/components/file-upload/file-upload.component";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import Swal, { SweetAlertIcon } from "sweetalert2";

interface Item {
  id?: number;
  url: string;
}

@Component({
  selector: "subida-documento-simple-component",
  templateUrl: "./subida-documento-simple.html",
  styleUrls: ["./subida-documento-simple.css"],
})
export class SubidaDocumentoSimpleComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  selectedFiles: File | File[] | FileList | null = null;
  private idLote: any = null;
  private lote: Lote;
  public maxFile = 400;
  public maxFileSize = 40;
  public multiple = true;
  public loteDetalleUrls: LoteDetalleUrl[] = [];
  public documentPdfUrl: SafeResourceUrl | null = null;
  public es_grupo: boolean = false;
  @ViewChild(FileUploadComponent) fileUploadComponent!: FileUploadComponent;
  @Output() primerPaso: EventEmitter<any> = new EventEmitter<any>();
  @Output() archivo: EventEmitter<any> = new EventEmitter<any>();
  /* TABLE */
  currentItems: Item[] = []; // Los datos para la página actual
  spinner: boolean;
  tableHeaders = [{ key: "url_real", label: "Url" }];
  customActions: TableAction[] = [];
  @ViewChild("content") showDocumentReference!: TemplateRef<any>;

  // Toast
  toast = Swal;

  constructor(
    private loteDetalleUrlService: LoteDetalleUrlService,
    private firmaStateService: FirmaStateService,
    private modalService: NgbModal,
    private loteService: LoteService,
    private sanitizer: DomSanitizer,
    public loading: LoadingService,
    private tours: HelpToursService,
    private pdfSanitizerService: PdfSanitizerService,
  ) {}
  ngOnDestroy(): void {
    this.tours.stop();
  }

  async ngAfterViewInit() {
    this.onHelp(true);
  }

  onHelp(force = false) {
    this.tours.start("step2_carga_documentos_help", force);
  }

  async ngOnInit() {
    this.toastAlert();
    await this.precargarData();

    this.customActions = [
      {
        label: "Ver Documento",
        handler: (item: Item) =>
          this.verDocumento(this.showDocumentReference, Number(item.id)),
        icon: "fa-solid fa-eye",
        colorClass: "bg-blue",
      },
      {
        label: "Eliminar",
        handler: (item: Item) => this.eliminarLoteDetalleUrl(Number(item.id)),
        icon: "fa-solid fa-trash-can",
        colorClass: "bg-red",
      },
    ];
  }

  async showLote(id: number) {
    const lote = await lastValueFrom(this.loteService.show(id));
    return lote;
  }

  async precargarData() {
    this.lote = this.firmaStateService.getCurrentState()?.lote;
    this.es_grupo = this.lote != null ? this.lote?.es_grupo : false;
    this.idLote = this.lote?.id;

    if (this.idLote) {
      await this.precargarDataSubidaDocumento();
    }
  }

  async precargarDataSubidaDocumento() {
    await this.indexLoteDetalleUrl();
  }

  async indexLoteDetalleUrl() {
    let response = null;
    if (!this.es_grupo) {
      response = await lastValueFrom(
        this.loteDetalleUrlService.indexDetalleUrl(this.idLote),
      );
      this.currentItems = response.body as LoteDetalleUrl[];
    } else {
      const ids_detalle_url = await this.loteDetalleGrupo();

      if (ids_detalle_url > 0) {
        const response = await lastValueFrom(
          this.loteDetalleUrlService.indexDetalleUrlGrupo(
            this.idLote,
            ids_detalle_url,
          ),
        );
        this.currentItems = [response.body] as LoteDetalleUrl[];
      } else {
        this.currentItems = [];
      }
    }
  }

  /*PARA LISTAR URLS POR RUPOOO*/
  async loteDetalleGrupo() {
    let params = new HttpParams();
    let data = null;
    const result = await lastValueFrom(
      this.loteDetalleUrlService.loteDetalleGrupo(this.idLote, params),
    );
    if (result.body.length > 0) {
      data = result?.body[0].ids_detalle_url;
    } else {
      data = 0;
    }
    return data;
  }

  async eliminarLoteDetalleUrl(idLoteDetalleUrl: number) {
    Swal.fire({
      title: "¡Eliminación de Archivo!",
      text: "¿Deseas eliminar este archivo?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(
          this.loteDetalleUrlService.deleteDetalleUrl(
            this.idLote,
            idLoteDetalleUrl,
          ),
        );
        this.alert("success", "Archivo eliminado correctamente");
        await this.indexLoteDetalleUrl();
      }
    });
  }

  handleFiles(files: any) {
    if (files.length > 0) {
      this.selectedFiles = files;

      let totaldocumentos = files.length + this.currentItems.length;
      this.archivo.emit({
        varios: totaldocumentos > 1,
        archivo: this.selectedFiles,
      });

      if (totaldocumentos === 1) {
        this.primerPaso.emit(0);
      }
    } else {
      this.archivo.emit({
        varios: files.length > 1,
        archivo: [],
      });
    }
  }

  async subirDocumentos(): Promise<boolean> {
    const files: File[] =
      this.selectedFiles instanceof File
        ? [this.selectedFiles]
        : Array.isArray(this.selectedFiles)
          ? this.selectedFiles
          : this.selectedFiles
            ? Array.from(this.selectedFiles as FileList)
            : [];

    if (files.length > 0) {
      try {
        const formData = new FormData();
        files.forEach((f) => formData.append("files", f, f.name));

        let es_grupo = this.lote?.es_grupo ?? false;
        formData.append("es_grupo", es_grupo ? "true" : "false");

        this.lote = this.firmaStateService.getCurrentState()?.lote;

        await lastValueFrom(
          this.loteDetalleUrlService.addDocumentToLote(this.lote.id, formData),
        );

        const loteUpdate = (await this.showLote(this.lote.id)) as Lote;
        this.firmaStateService.updateLote(loteUpdate);

        this.alert("success", "Documentos cargados correctamente");

        this.fileUploadComponent.clearFiles();

        return true;
      } catch (error) {
        console.error(error);
        this.alert("error", "Error al subir documentos");
        return false;
      }
    }

    let validarDocumentos = await this.validCantidadDocumentos();

    if (!validarDocumentos) {
      this.alert("warning", "Debe seleccionar o arrastrar un documento");
      return false;
    }

    return true;
  }

  public async validCantidadDocumentos(): Promise<boolean> {
    return this.currentItems.length ? true : false;
  }

  async verDocumento(content: any, idDetalleUrl: any) {
    const { body } = await lastValueFrom(
      this.loteDetalleUrlService.showDetalleUrl(this.idLote, idDetalleUrl),
    );

    const safeUrl = this.pdfSanitizerService.getTrustedPdfUrl(
      body?.url_documento,
    );

    if (!safeUrl) {
      this.alert("error", "El documento no es válido");
      return;
    }

    this.documentPdfUrl = safeUrl;

    this.modalService.open(content, {
      centered: true,
      size: "xl",
    });
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string) {
    this.toast.fire({
      icon: icontext,
      title: title,
    });
  }
}
